import { Box, Stack, Typography, useTheme } from "@mui/material";
import { Popup as Modal } from "devextreme-react/popup";

//import DataGrid from "devextreme-react/data-grid";

import DataGrid, {
  FilterRow,
  HeaderFilter,
  Selection,
  Column,
  ColumnFixing,
  ColumnChooser,
  Form,
  LoadPanel,
  Popup,
  Texts,
  Editing,
  Lookup,
  RequiredRule,
  Paging,
  Pager,
} from "devextreme-react/data-grid";
import { TextBox, Button as TextBoxButton } from "devextreme-react/text-box";

import Button from "devextreme-react/button";
import Toolbar, { Item } from "devextreme-react/toolbar";
import React, { useState, useRef, useEffect, useCallback } from "react";

import "./style.css";
import useMediaQuery from "@mui/material/useMediaQuery";

import { useDispatch, useSelector } from "react-redux";

import { DataGridConfig } from "../../config";

import { getCompany, setFilter } from "../../store/reducers/company";
import BaseHelper from "../../helper/BaseHelper";
import moment from "moment";
import notify from "devextreme/ui/notify";
import {
  getVehicleSearchDataFun,
  getViolationOffenderFun,
  setViolationOffenderData,
  setVehicleSearchData,
  getViolationLegalPenaltyFun,
  getViolationCompanyCrudFun,
  getViolationCompanyEditFun,
  getViolationLegalProvisionFun,
  getViolationDetectionTypeFun,
  getViolationTypeDataFun,
  getViolationCitizenTypeData,
  getviolationServiceTypeCrudFun,
  getViolationDecisionTypeFun,
} from "../../store/reducers/metaCrud";
import { RadioGroup } from "devextreme-react";
import { getUserListData } from "../../store/reducers/user/auth";
import {
  getViolation,
  violationDeleteFun,
  violationEditFun,
} from "../../store/reducers/violation";
import FilterBox from "./filter";
//import { setVehicleSearchData } from "../../store/reducers/vehicle";
const priorityEntities = [
  { id: 0, text: "Тийм" },
  { id: 1, text: "Үгүй" },
];
const ViolationList = (props) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const violationOffenderData = useSelector(
    (state) => state.metaCrud.violationOffenderData
  );
  const getVehicleSearchData = useSelector(
    (state) => state.metaCrud.vehicleSearchData
  );
  const getViolationCompanyData = useSelector(
    (state) => state.metaCrud.violationCompanyData
  );
  const violationLegalPenaltyList = useSelector(
    (state) => state.metaCrud.violationLegalPenalty
  );
  const getViolationCompanyFilter = useSelector(
    (state) => state.metaCrud.violationCompanyFilter
  );
  const getViolationLegalProvisionData = useSelector(
    (state) => state.metaCrud.violationLegalProvisionData
  );
  const violationDetectionTypeList = useSelector(
    (state) => state.metaCrud.violationDetectionType
  );
  const violationTypeDataList = useSelector(
    (state) => state.metaCrud.violationTypeData
  );
  const violationCitizenTypeDataList = useSelector(
    (state) => state.metaCrud.violationCitizenTypeData
  );
  const violationServiceTypeCrudList = useSelector(
    (state) => state.metaCrud.violationServiceTypeCrud
  );
  const violationDecisionTypeData = useSelector(
    (state) => state.metaCrud.violationDecisionType
  );
  const userListData = useSelector((state) => state.auth.userListData);
  const filter = useSelector((state) => state.violation.filter);
  const isLoading = useSelector((state) => state.metaCrud.isLoading);
  const getIsLoading = useSelector((state) => state.violation.isLoading);
  const filterComp = useSelector((state) => state.company.filter);
  const getCompanyList = useSelector((state) => state.company.companyData);
  const [showFilterRow, setShowFilterRow] = useState(true);
  const [showHeaderFilter, setShowHeaderFilter] = useState(true);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [currentFilter, setCurrentFilter] = useState("full");
  const [isCompChange, setIsCompChange] = useState(false);

  const [selectIndex, setSelectIndex] = useState(-1);
  const [editData, setEditData] = useState([]);
  const logedUser = useSelector((state) => state.auth.user);
  const [formData, setFormData] = useState([]);
  const [direction, setDirection] = useState("up-push");
  const [phonNumber, setPhonNumber] = useState(
    props.driverEditData ? props.driverEditData.phone_number : ""
  );
  const [register, setRegister] = useState("");
  const [plate, setPlate] = useState("");
  const [formEditData, setFormEditData] = useState("");
  const [isConfirm, setIsConfirm] = useState(false);
  const [coordinatePosition, setCoordinatePosition] = useState({
    top: 40,
    left: "50%",
    bottom: undefined,
    right: undefined,
  });
  const [selectionPriority, setSelectionPriority] = useState(
    priorityEntities[0].id
  );
  const [checkBoxValue, setCheckBoxValue] = useState(true);
  const [isCompAdd, setIsCompAdd] = useState(false);
  const [newComp, setNewComp] = useState("");
  const [newCompReg, setNewCompReg] = useState("");
  const [newCompPhone, setNewCompPhone] = useState("");
  const [newCompAddress, setNewCompAddress] = useState("");
  const [selectedValue, setSelectedValue] = useState(null);

  const setFilters = (field, value) => {
    //console.log(field, value);
    dispatch(setFilter({ ...filter, [field]: value }));
    // dispatch(getViolation(filter));
  };
  useEffect(() => {
    // gridRef.current.instance.beginCustomLoading();
    if (props.violationDataList) {
      setFormData(props.violationDataList);
      //    gridRef.current.instance.endCustomLoading();
    }
  }, [filter, props]);
  function timeout(number) {
    return new Promise((res) => setTimeout(res, number));
  }
  const test = async () => {
    //for 1 sec delay
    await timeout(5000);
  };
  useEffect(() => {
    if (userListData == null) {
      // gridRef.current.instance.beginCustomLoading();
      dispatch(
        getUserListData({
          search_value: "",
          user_type_id: 12,
        })
      );
    }
  }, [userListData, dispatch]);
  useEffect(() => {
    if (violationLegalPenaltyList === null) {
      dispatch(getViolationLegalPenaltyFun());
    }
  }, [violationLegalPenaltyList, dispatch]);
  useEffect(() => {
    if (Object.keys(getViolationCompanyFilter).length === 0) {
      dispatch(getViolationCompanyCrudFun(getViolationCompanyFilter));
    }
  }, [getViolationCompanyFilter, dispatch]);
  useEffect(() => {
    if (Object.keys(filterComp).length === 0) {
      dispatch(setFilter({ is_basic: 1 }));
    }
  }, [filterComp, getCompanyList, dispatch]);
  useEffect(() => {
    if (getCompanyList == null && Object.keys(filterComp).length > 0) {
      dispatch(getCompany(filterComp));
    }
  }, [filterComp, getCompanyList, dispatch]);
  useEffect(() => {
    if (getViolationLegalProvisionData === null) {
      dispatch(getViolationLegalProvisionFun());
    }
  }, [getViolationLegalProvisionData, dispatch]);
  useEffect(() => {
    if (violationDetectionTypeList === null) {
      dispatch(getViolationDetectionTypeFun());
    }
  }, [violationDetectionTypeList, dispatch]);
  useEffect(() => {
    if (violationTypeDataList === null) {
      dispatch(getViolationTypeDataFun());
    }
  }, [violationTypeDataList, dispatch]);
  useEffect(() => {
    if (violationCitizenTypeDataList === null) {
      dispatch(getViolationCitizenTypeData());
    }
  }, [violationCitizenTypeDataList, dispatch]);
  useEffect(() => {
    if (violationServiceTypeCrudList === null) {
      dispatch(getviolationServiceTypeCrudFun());
    }
  }, [violationServiceTypeCrudList, dispatch]);
  useEffect(() => {
    if (violationDecisionTypeData === null) {
      dispatch(getViolationDecisionTypeFun());
    }
  }, [violationDecisionTypeData, dispatch]);

  //console.log(props);
  const gridRef = useRef();

  const onSelectionChanged = ({ selectedRowKeys, selectedRowsData }) => {
    // console.log(selectedRowKeys);
    //console.log(selectedRowsData[0]);
    setSelectIndex(selectedRowKeys[0]);

    // setIsType(2);
    setFormEditData(selectedRowsData[0]);
  };
  const searchButton = {
    icon: "/assets/eye.png",
    //stylingMode: "outlined",

    //icon: "fa fa-envelope-o",
    type: "default",
    disabled: isLoading,
    onClick: (e) => {
      dispatch(getViolationOffenderFun({ register: register }));
      //  dispatch(getDriverSearch(register));
      //  searchVeh(e);
      // dispatch(getVehicleSearch(plateValue));
      // dispatch(getVehicleInspectionData(plateValue));
    },
  };
  const searchButtonPlate = {
    icon: "/assets/eye.png",
    //stylingMode: "outlined",

    //icon: "fa fa-envelope-o",
    type: "default",
    disabled: isLoading,
    onClick: (e) => {
      dispatch(getVehicleSearchDataFun({ plate_no: plate }));
      //  dispatch(getDriverSearch(register));
      //  searchVeh(e);
      // dispatch(getVehicleSearch(plateValue));
      // dispatch(getVehicleInspectionData(plateValue));
    },
  };
  // console.log(props.compData !== null ? props.comptData.id : "");
  const onValueChange = useCallback((v) => {
    const result = v;

    setRegister(result);
  }, []);
  const onValueChangePlate = useCallback((v) => {
    const result = v;

    setPlate(result);
  }, []);
  const onValueChangePhone = useCallback((v) => {
    const result = v;

    setPhonNumber(result);
  }, []);
  //console.log(props);
  const dateConverter = (startDate, timeEnd) => {
    const newStartDate = new Date(startDate);
    const newEndDate = new Date(timeEnd);
    let result = moment(newStartDate).diff(newEndDate, "days");

    return result;
    // const startDat = moment(startDate);
    // const timeEn = moment(timeEnd);
    // const diff = timeEn.diff(startDat);
    // const diffDuration = moment.duration(diff);
    // return diffDuration.days();
  };
  // console.log(violationOffenderData);
  const onSaving = React.useCallback(
    (e) => {
      // e.cancel = true;
      // console.log(e.changes[0]);
      const selectedData = gridRef.current.instance.getSelectedRowsData();
      // console.log(selectedData);
      if (e.changes[0] !== undefined) {
        if (e.changes[0].type === "insert") {
          // console.log(e.changes);
          const data = e.changes[0].data;

          if (Object.keys(data).length > 0) {
            data["id"] = 0;
            data["offender_id"] =
              violationOffenderData !== null ? violationOffenderData.id : "";
            if (getVehicleSearchData !== null) {
              data["vehicle_id"] = getVehicleSearchData.id;
            }

            // data["legal_provision_id"] = 1;
            // data["is_active"] = 1;
          }
          dispatch(violationEditFun(data));

          // console.log(data);
          gridRef.current.instance.cancelEditData();
          e.cancel = true;
          // e.component.cancelEditData();
          gridRef.current.instance.cancelEditData();
        } else if (e.changes[0].type === "update") {
          const data = e.changes[0].data;
          //  console.log(data);
          data["id"] = e.changes[0].key;
          data["offender_id"] =
            violationOffenderData !== null
              ? violationOffenderData.id
              : selectedData[0].offender_id;
          data["vehicle_id"] =
            getVehicleSearchData !== null
              ? getVehicleSearchData.id
              : selectedData[0].vehicle_id;
          // data["legal_provision_id"] = 1;
          // data["is_active"] = 1;
          // if ("code" in data === false) {
          //   data["code"] = selectedData[0].code;
          // }
          // if ("rank" in data === false) {
          //   data["rank"] = selectedData[0].rank;
          // }
          // if ("name" in data === false) {
          //   data["name"] = selectedData[0].name;
          // }
          //console.log(data);
          dispatch(violationEditFun(data));
          gridRef.current.instance.cancelEditData();

          e.cancel = true;
        } else if (e.changes[0].type === "remove") {
          // console.log(e.changes[0].key);
          const data = { id: e.changes[0].key };
          // console.log(data);
          dispatch(violationDeleteFun(data));

          e.cancel = true;
          gridRef.current.instance.cancelEditData();
        }
      }
      // e.component.cancelEditData();
    },
    [violationOffenderData, getVehicleSearchData, dispatch]
  );
  // console.log(violationOffenderData);
  const onValueChecked = useCallback(
    (e) => {
      setSelectionPriority(e.value);
      //  console.log(e.value);
      if (e.value === 0) {
        setCheckBoxValue(true);
      } else {
        setCheckBoxValue(false);
      }
    },
    [setSelectionPriority]
  );
  const hideInfo = () => {
    setIsCompAdd(false);

    // setFormEditData("");
  };
  const addVoilComp = () => {
    // console.log(newCompReg);
    if (
      newCompAddress === "" ||
      newComp === "" ||
      newCompPhone === "" ||
      newCompReg === ""
    ) {
      BaseHelper.nodifyFun("Мэдээлэл гүйцэд оруулан уу!!", "error");
    } else {
      var data = {
        address: newCompAddress,
        id: 0,
        name: newComp,
        phone_number: newCompPhone,
        regnum: newCompReg,
      };
      // console.log(newValue);
      dispatch(getViolationCompanyEditFun(data));
      setIsCompAdd(false);
      setNewComp("");
      setNewCompAddress("");
      setNewCompPhone("");
      setNewCompReg();
    }

    // setSearchValuePlate(newValue);
  };
  return (
    <>
      {/* <Box id="descContainer">dsdsvdsvs</Box> */}
      <Toolbar>
        <Item location="before">
          <Box sx={{ ml: 2 }}>
            <Button
              icon={"refresh"}
              onClick={() => {
                dispatch(getViolation(filter));
                gridRef.current.instance.refresh();
              }}
              type={"normal"}
              text="Сэргээх"
            />
          </Box>
        </Item>
        <Item location="before">
          <Box sx={{ ml: 1 }}>
            <Button
              disabled={
                BaseHelper.permitionCheck(5, 0, "is_create", logedUser) ===
                false
                  ? true
                  : false
              }
              icon={"add"}
              onClick={() => {
                gridRef.current.instance.addRow();
              }}
              type={"default"}
              text="Шинэ"
            />
          </Box>
        </Item>
        <Item location="before">
          <FilterBox getFilters={setFilters} />
        </Item>

        <Item location="after">
          <Box>
            {/* <Button
                  icon={"export"}
                  onClick={() => {
                    gridRef.current.instance.exportToExcel();
                  }}
                /> */}
            <Button
              onClick={() => {
                gridRef.current.instance.exportToExcel();
              }}
            >
              <Box sx={{ background: "#fff", p: 0.5 }}>
                <img src="/assets/excel.png" alt="" className="dx-icon" />
              </Box>
            </Button>
          </Box>
        </Item>
      </Toolbar>

      <DataGrid
        ref={gridRef}
        {...DataGridConfig}
        // showRowLines={true}
        //  searchPanel={{ visible: true, placeholder: "Хайлт" }}
        // repaintChangesOnly={true}
        // onEditorPreparing={(e) => {

        //   if (e.parentType === "dataRow" && e.dataField === "checked_by") {
        //     e.editorOptions.onHiding = () => {
        //       // Ensure value remains selected after popup hides

        //       if (e.value) {
        //         setSelectedValue(e.value);
        //       }
        //     };
        //     e.editorOptions.onValueChanged = (event) => {
        //       setSelectedValue(event.value);
        //       e.setValue(event.value);
        //     };
        //   }
        // }}
        rowAlternationEnabled={true}
        remoteOperations={true}
        dataSource={formData}
        keyExpr="id"
        onCellPrepared={(e) => {
          // console.log(e.data ? e.data.violation_date : "");
          if (e.rowType === "data" && e.column.dataField === "violation_date") {
            const date = dateConverter(Date.now(), e.data.violation_date);
            //  console.log({ date });
            if (e.row.data.decision_type_id === 2 && date < 15) {
              e.cellElement.style.backgroundColor = "pink";
              //  e.rowElement.style.backgroundColor = "red";
              // console.log(date);
            } else if (e.row.data.decision_type_id === 2 && date > 14) {
              e.cellElement.style.backgroundColor = "red";
              //   e.rowElement.style.backgroundColor = "orange";
              // e.cellElement.style.backgroundColor = "orange";
            } else if (e.row.data.decision_type_id === 10 && date <= 0) {
              e.cellElement.style.backgroundColor = "#00c3ff";
              // console.log(-3 > -4);
              // console.log(date);
              //   e.rowElement.style.backgroundColor = "orange";
              // e.cellElement.style.backgroundColor = "orange";
            } else if (
              e.row.data.decision_type_id === 10 &&
              date >= 3 &&
              date <= 5
            ) {
              e.cellElement.style.backgroundColor = "orange";
              //   e.rowElement.style.backgroundColor = "orange";
              // e.cellElement.style.backgroundColor = "orange";
            } else if (e.row.data.decision_type_id === 10 && date > 5) {
              e.cellElement.style.backgroundColor = "red";
              //   e.rowElement.style.backgroundColor = "orange";
              // e.cellElement.style.backgroundColor = "orange";
            } else {
            }
          }
        }}
        onEditCanceling={(e) => {
          // console.log(e.changes);
          if (e.changes.length === 0) {
            setRegister("");
            setPlate("");
            dispatch(setViolationOffenderData(null));
            dispatch(setVehicleSearchData(null));
          }
        }}
        onEditingStart={(e) => {
          // if (!e.data || !e.data.id) {
          //   console.log("Adding a new row, clearing previous selections...");
          // } else {
          //   console.log("Editing an existing row:", e.data);
          // }
          setRegister(e.data.offender_register);
          setPlate(e.data.plate_no);
          //  dispatch(setDriverSearchData(null));
          setIsCompChange(true);
        }}
        // onEditCanceled={(e) => {
        //   setIsCompChange(false);
        //   setRegister(null);
        //   setRegister(null);
        // }}
        height={550}
        //wordWrapEnabled={true}
        onRowDblClick={(row) => {
          setFormEditData(row.data);
          // console.log(row);
          dispatch(getVehicleSearchDataFun({ plate_no: row.data.plate_no }));

          // setSearchValuePlate(row.data.plate_no);
          dispatch(
            getViolationOffenderFun({
              register: row.data.offender_register,
            })
          );
          //setSearchValue(row.data.offender_register);
          gridRef.current.instance.editRow(row.rowIndex);
          //   const start = moment().add(-4, "m");
          //  console.log(dateConverter(Date.now(), "2023-10-01"));
        }}
        //   defaultSelectionFilter={selectionFilter}
        onSelectionChanged={onSelectionChanged}
        onSaving={onSaving}
      >
        <Editing
          mode="popup"
          allowUpdating={BaseHelper.permitionCheck(
            39,
            0,
            "is_update",
            logedUser
          )}
          allowDeleting={BaseHelper.permitionCheck(
            39,
            0,
            "is_delete",
            logedUser
          )}
          useIcons={true}
          //  changes={changes}
          //  onChangesChange={setChanges}
        >
          <Popup
            title="Зөрчил"
            showTitle={true}
            width={!isNonMobile ? "100%" : "70%"}
            height={!isNonMobile ? "100%" : "60%"}
          />
          <Texts
            confirmDeleteMessage="Та энэ үйлдлийг хийх үү?"
            confirmDeleteTitle={"Мэдээлэл устгах"}
            saveRowChanges={"Хадгалах"}
            saveRowToNode={"ffff"}
            cancelRowChanges={"Цуцлах"}
            deleteRow="Устгах"
            addRow="Нэмэх"
            editRow="Засах"
            addRowToNode="Нэмэх"
          />
          <Form>
            <Item itemType="group" colCount={1} colSpan={2}>
              <Item itemType="group" colCount={2} colSpan={2}>
                <Item dataField={"offender_register"} />
                <Item dataField={"plate_no"} />
                <Item dataField={"offender_lastname"} />
                <Item dataField={"mark_name"} />
                {/* <Item dataField={"garage_no"} /> */}

                <Item dataField={"checked_by"} />

                <Item dataField="violation_date" />
              </Item>

              <Item
                itemType="group"
                caption="Зөрчил дэлгэрнгүй"
                colCount={1}
                colSpan={2}
              >
                <Item dataField="number" />
                <Item dataField="detected_by" />
                <Item dataField="isComp" />
                <Item itemType="group" colCount={5}>
                  <Item
                    dataField="company_id"
                    colSpan={4}
                    // disabled={true}
                  />
                  <Item>
                    <Button
                      disabled={checkBoxValue ? false : true}
                      icon="plus"
                      onClick={() => {
                        setIsCompAdd(true);
                      }}
                    />
                  </Item>
                </Item>
                {/* <Item dataField="company_id" /> */}
                <Item dataField="legal_penalty_id" />
                <Item dataField="legal_provision_id" />
                <Item dataField="detection_type_id" />
                <Item dataField="type_id" />
                <Item dataField="citizen_type_id" />
                <Item dataField="service_type_id" />
                <Item dataField="decision_type_id" />
                <Item dataField="address" />

                {/* <Item dataField={"picture_url"} /> */}
              </Item>
              <Item
                itemType="group"
                caption="Поркурор"
                colCount={2}
                colSpan={2}
              >
                <Item dataField="court_number" />
                <Item dataField="prosecutor_name" />
                <Item dataField="court_checked_date" />
                <Item dataField="court_recieved_date" />
                <Item dataField="court_presented_date" />
                <Item dataField="court_reviewed_date" />
                <Item dataField="court_decision" />
              </Item>
            </Item>
          </Form>
        </Editing>
        <FilterRow visible={true} />
        <Selection mode="multiple" />
        <ColumnChooser enabled={false} />
        <ColumnFixing enabled={true} />
        <Column
          allowSorting={true}
          caption="#"
          cellRender={(e) => {
            return e.rowIndex + 1;
          }}
          fixed={true}
          alignment={"center"}
        />
        <Column
          alignment={"center"}
          caption={"Зөрчил үйлдсэн хүн, хуулийн этгээд"}
        >
          <Column
            dataField="offender_lastname"
            allowEditing={false}
            format="fixedPoint"
            caption={"Зөрчил гаргагч"}
            editCellRender={(v) => {
              return (
                <TextBox
                  readOnly
                  value={
                    violationOffenderData
                      ? violationOffenderData.lastname !== null
                        ? `${violationOffenderData.lastname} ${violationOffenderData.firstname}`
                        : "Мэдээлэл олдсонгүй"
                      : v.data.offender_lastname !== null &&
                        typeof v.data.offender_lastname !== "undefined"
                      ? `${v.data.offender_lastname} ${v.data.offender_firstname}`
                      : ""
                  }
                  valueChangeEvent="input"
                />
              );
            }}
            cellRender={(v) => {
              //  console.log(v);
              return v.value !== null
                ? v.value.substring(0, 1) + "." + v.data.offender_firstname
                : v.data.offender_firstname;
            }}
          />
          <Column
            dataField="offender_register"
            //format="fixedPoint"
            caption={"Регистер"}
            cellRender={(e) => {
              return e.value;
            }}
            editCellRender={(e) => {
              // console.log(e);
              return (
                <TextBox
                  value={register}
                  placeholder="Регистерийн дугаар"
                  onValueChange={onValueChange}
                  showClearButton={true}
                  valueChangeEvent="input"
                  inputAttr={{ style: "text-transform: uppercase" }}
                >
                  <TextBoxButton
                    name="password"
                    location="after"
                    options={searchButton}
                  />
                </TextBox>
              );
            }}
          />

          <Column
            alignment={"center"}
            dataField="isComp"
            visible={false}
            //  hidingPriority={1}
            editCellRender={(e) => {
              return (
                // <CheckBox
                //   value={
                //     getViolationCompanyData !== null && checkBoxValue
                //       ? true
                //       : false
                //   }
                //   text={checkBoxValue ? "Тийм" : "Үгүй"}
                //   onValueChanged={onValueChecked}
                // />
                <RadioGroup
                  layout="horizontal"
                  id="radio-group-with-selection"
                  items={priorityEntities}
                  value={selectionPriority}
                  defaultValue={priorityEntities[0]}
                  valueExpr="id"
                  displayExpr="text"
                  onValueChanged={onValueChecked}
                />
              );
              // console.log(e.value);
            }}
            // editCellRender={cellEditRenderFun}
            caption={"Харьяалах ААНБ сонгох эсэх"}
          />
          <Column
            alignment={"center"}
            dataField="company_id"
            width={120}
            allowEditing={checkBoxValue ? true : false}
            caption="Харьяалах ААНБ"
          >
            {/* <RequiredRule /> */}
            <Lookup
              dataSource={getViolationCompanyData}
              valueExpr="id"
              displayExpr="name"
            />
          </Column>
          <Column
            alignment={"center"}
            dataField="detected_by"
            caption={"Зөрчлийг илрүүлсэн"}
          >
            <RequiredRule />
            <Lookup
              dataSource={userListData}
              valueExpr="id"
              displayExpr="firstname"
            />
          </Column>
          <Column
            alignment={"center"}
            dataField="legal_penalty_id"
            caption="Зөрчигдсөн хуулийн заалт"
            width={220}
          >
            <RequiredRule />
            <Lookup
              dataSource={violationLegalPenaltyList}
              valueExpr="id"
              displayExpr="name"
            />
          </Column>
        </Column>
        <Column
          alignment={"center"}
          caption={"Зөрчил үйлдсэн хугацаа, шийтгэлийн дугаар "}
          dataField={"number"}
        />
        <Column
          alignment={"center"}
          //  legal_provision_id
          dataField="legal_provision_id"
          caption=" Зөрчлийн тухай хуулийн зүйл, хэсэг"
          width={220}
        >
          <RequiredRule />
          <Lookup
            dataSource={getViolationLegalProvisionData}
            valueExpr="id"
            displayExpr="name"
          />
        </Column>
        <Column
          alignment={"center"}
          dataField="legal_penalty_amount"
          caption={"Оногдуулсан шийтгэл"}
        />

        <Column
          alignment={"center"}
          dataField="checked_by"
          caption={"Зөрчлийн шалган шийдвэрлэсэн"}
        >
          <RequiredRule />
          <Lookup
            dataSource={userListData}
            valueExpr="id"
            displayExpr="firstname"
          />
        </Column>
        <Column
          alignment={"center"}
          dataField="detection_type_id"
          //value={10}
          caption="Илрүүлэлт"
        >
          <RequiredRule />
          <Lookup
            //defaultValue={violationDetectionTypeList[0].id}
            dataSource={violationDetectionTypeList}
            valueExpr="id"
            displayExpr="name"
          />
        </Column>
        <Column alignment={"center"} dataField="type_id" caption="Зөрчил">
          <RequiredRule />
          <Lookup
            dataSource={violationTypeDataList}
            valueExpr="id"
            displayExpr="name"
          />
        </Column>
        <Column
          alignment={"center"}
          dataField="citizen_type_id"
          caption="Хүн/ААН"
        >
          <RequiredRule />
          <Lookup
            dataSource={violationCitizenTypeDataList}
            valueExpr="id"
            displayExpr="name"
          />
        </Column>
        <Column
          alignment={"center"}
          dataField="violation_date"
          format="yyyy-MM-dd HH:mm:ss"
          dataType="datetime"
          caption={"Зөрчил гаргасан огноо"}
        />
        <Column
          alignment={"center"}
          dataField="service_type_id"
          caption="Үйлчилгээ"
          width={125}
        >
          <RequiredRule />
          <Lookup
            dataSource={violationServiceTypeCrudList}
            valueExpr="id"
            displayExpr="name"
          />
        </Column>
        <Column
          alignment={"center"}
          dataField="decision_type_id"
          caption="Хэрэг"
          //   value={9}
          width={125}
        >
          <RequiredRule />
          <Lookup
            dataSource={violationDecisionTypeData}
            valueExpr="id"
            displayExpr="name"
          />
        </Column>
        <Column alignment={"center"} caption={"Удирдамжийн нэр"} />
        <Column
          dataField="garage_no"
          allowEditing={false}
          format="fixedPoint"
          caption={"Грааш дугаар"}
          editCellRender={(v) => {
            // console.log(v.data.garage_no);
            return (
              <TextBox
                readOnly
                value={v.data.garage_no}
                valueChangeEvent="input"
              />
            );
          }}
        />
        <Column
          dataField="plate_no"
          //format="fixedPoint"
          caption={"Улсын дугаар"}
          cellRender={(e) => {
            return e.value;
          }}
          editCellRender={(e) => {
            // console.log(e);
            return (
              <TextBox
                value={plate}
                placeholder="Улсын дугаар эсвэл грааш дугаар"
                onValueChange={onValueChangePlate}
                showClearButton={true}
                valueChangeEvent="input"
                inputAttr={{ style: "text-transform: uppercase" }}
              >
                <TextBoxButton
                  name="password"
                  location="after"
                  options={searchButtonPlate}
                />
              </TextBox>
            );
          }}
        />
        <Column alignment={"center"} dataField="address" caption={"Хаяг"}>
          <RequiredRule />
        </Column>
        <Column
          alignment={"center"}
          dataField="prosecutor_name"
          caption={"Прокурорын нэр"}
        />

        <Column
          dataField="mark_name"
          allowEditing={false}
          format="fixedPoint"
          caption={"Марк,Загвар"}
          editCellRender={(v) => {
            return (
              <TextBox
                readOnly
                value={
                  getVehicleSearchData
                    ? `${getVehicleSearchData.mark_name} ${getVehicleSearchData.model_name}`
                    : v.data.mark_name !== null &&
                      typeof v.data.mark_name !== "undefined"
                    ? `${v.data.mark_name} ${v.data.model_name}`
                    : ""
                }
                valueChangeEvent="input"
              />
            );
          }}
        />
        <Column
          alignment={"center"}
          dataField="court_number"
          caption="Бүртгэлийн дугаар"
        />
        <Column
          alignment={"center"}
          dataField="court_checked_date"
          caption={"Шалгасан хоног"}
          editorOptions={{
            mode: "number",
          }}
        />
        <Column
          alignment={"center"}
          dataField="court_recieved_date"
          editorOptions={{
            mode: "date",
          }}
          caption={"Гомдол хүлээн авсан өдөр"}
        />
        <Column
          alignment={"center"}
          dataField="court_presented_date"
          caption={"Прокурорт танилцуулсан өдөр"}
          editorOptions={{
            mode: "date",
          }}
        />
        <Column
          alignment={"center"}
          caption={"гомдол гаргагчийн талаарх мэдээлэл"}
        />
        <Column
          alignment={"center"}
          dataField="court_reviewed_date"
          caption={"Прокурор хянасан өдөр"}
          editorOptions={{
            mode: "date",
          }}
        />
        <Column alignment={"center"} caption={"ЭБАТ"}>
          <Column alignment={"center"} caption={"Зөрчлийн хэрэг нээсэн"} />
        </Column>
        <Column
          alignment={"center"}
          caption={"Зөрчлийн хэргийг прокурор хянаад"}
        >
          <Column
            alignment={"center"}
            caption={"Зөрчлийн хэргийн дугаар олгосон"}
          />
          <Column
            alignment={"center"}
            caption={"Харьяаллын дагуу шилжүүлсэн"}
          />
          <Column
            alignment={"center"}
            caption={"Эрх бүхий албан тушаалтны шийдвэрийг хүчингүй болгосон"}
          />
        </Column>
        <Column alignment={"center"} caption={"дээд шатны прокурор"}>
          <Column alignment={"center"} caption={"Шийдвэрийг хэвээр үлдээсэн"} />
          <Column
            alignment={"center"}
            caption={"Шийдвэрийг хүчингүй болгосон"}
          />
          <Column alignment={"center"} caption={"Шийдвэрт өөрчлөлт оруулсан"} />
        </Column>

        <Column
          width={220}
          caption={
            "Прокурор ЗШШТХуулийн 1.12 дугаар зүйлийн 6 дахь хэсэгт зааснаар эрх бүхий албан тушаалтны шийдвэрийн биелэлтийг түдгэлзүүлсэн он, сар, өдөр, шийдвэрийн дугаар"
          }
        />
        <Column caption={"ЭБАТ татгалзсан"} />
        <Column caption={"ЭБАТ харъяаллын дагуу шилжүүлсэн"} />
        <Column caption={"ӨРШӨӨЛ"} />
        <Column caption={"АРХИВ КОД"} />
        <Column
          dataField="created_at"
          format="yyyy-MM-dd HH:mm"
          dataType="date"
          caption={"Бүртгэсэн"}
        />
        <Paging defaultPageSize={50} />
        <Pager
          visible={true}
          showPageSizeSelector={true}
          allowedPageSizes={[20, 50, 100, 200, 500, 1000]}
          showNavigationButtons={true}
          showInfo={true}
        />
        <FilterRow visible={showFilterRow} applyFilter={currentFilter} />
        <HeaderFilter visible={showHeaderFilter} />

        <LoadPanel enabled={true} />
      </DataGrid>
      <Modal
        dragEnabled={false}
        hideOnOutsideClick={true}
        showCloseButton={true}
        visible={isCompAdd}
        showTitle={true}
        title="Зөрчил үйлдсэн ААНБ бүртгэх"
        onHiding={hideInfo}
        width={"60%"}
        height={400}
      >
        <Stack direction={"column"} justifyContent={"start"} spacing={2}>
          <Stack direction={"row"} spacing={2} justifyContent={"space-between"}>
            <Box sx={{ width: "50%" }}>
              <Typography sx={{ textAlign: "start", mb: 1 }}>Нэр</Typography>
              <TextBox
                value={newComp}
                // onValueChange={onValueChange}
                onKeyUp={(e) => {
                  e.event.preventDefault();
                  setNewComp(e.event.target.value);
                }}
                placeholder="Аж ахуй нэгжийн нэр."
                // console.log(e);
                // setPlateValue(e);
                //  }}
              />
            </Box>
            <Box sx={{ width: "50%" }}>
              <Typography sx={{ textAlign: "start", mb: 1 }}>
                Регистер
              </Typography>
              <TextBox
                value={newCompReg}
                // onValueChange={onValueChange}
                onKeyUp={(e) => {
                  e.event.preventDefault();
                  setNewCompReg(e.event.target.value);
                }}
                placeholder="Аж ахуй нэгжийн регистер."
                // console.log(e);
                // setPlateValue(e);
                //  }}
              />
            </Box>
          </Stack>
          <Stack direction={"row"} spacing={2} justifyContent={"space-between"}>
            <Box sx={{ width: "50%" }}>
              <Typography sx={{ textAlign: "start", mb: 1 }}>Утас</Typography>
              <TextBox
                value={newCompPhone}
                // onValueChange={onValueChange}
                onKeyUp={(e) => {
                  e.event.preventDefault();
                  setNewCompPhone(e.event.target.value);
                }}
                placeholder="Аж ахуй нэгжийн утас."
                // console.log(e);
                // setPlateValue(e);
                //  }}
              />
            </Box>
            <Box sx={{ width: "50%" }}>
              <Typography sx={{ textAlign: "start", mb: 1 }}>Хаяг</Typography>
              <TextBox
                value={newCompAddress}
                // onValueChange={onValueChange}
                onKeyUp={(e) => {
                  e.event.preventDefault();
                  setNewCompAddress(e.event.target.value);
                }}
                placeholder="Аж ахуй нэгжийн хаяг."
                // console.log(e);
                // setPlateValue(e);
                //  }}
              />
            </Box>
          </Stack>
        </Stack>
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            right: 4,
            height: "45px",
          }}
        >
          <Stack direction={"row"} spacing={2}>
            <Button
              width={120}
              text="Хаах"
              type="normal"
              stylingMode="contained"
              onClick={hideInfo}
            />
            <Button
              width={120}
              text="Бүртгэх"
              type="normal"
              stylingMode="contained"
              onClick={addVoilComp}
            />
          </Stack>
        </Box>
      </Modal>
    </>
  );
};

export default ViolationList;
